import React, { useState, useEffect, useCallback } from "react";
import IntentsGrid from "./IntentsGrid";
import IntentsTiles from "./IntentsTiles";
import IntentsFilter from "./IntentsFilter";
import Tools from "../utils/Tools";
import { useFilter } from "../contexts/FilterContext";

function IntentsPage() {
  const { filters, setFilters } = useFilter();
  const [loadingSummary, setLoadingSummary] = useState(true);
  const [intents, setIntents] = useState([]);
  const [queues, setQueues] = useState([]);
  const [initiationMethods, setInitiationMethods] = useState([]);
  const [totalCalls, setTotalCalls] = useState(0);
  const [filteredIntents, setFilteredIntents] = useState(null);

  // Todo: refactor
  function formatDateToYYYYMMDD(date) {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const onLocalFilter = (intents) => {
    console.log("onLocalFilter() called");
    setFilteredIntents(intents);
  };


  // Fetch summary data from server whenever filters change
  useEffect(() => {
    setLoadingSummary(true);
    const queryParams = new URLSearchParams();
    if (filters.dateRange) {
      queryParams.append("dateRange", filters.dateRange.value);
    }
    if (filters.queue && filters.queue.length > 0) {
      filters.queue.forEach(queue => {
        queryParams.append("queue", queue.value);
      });
    }
    if (filters.initiationMethod && filters.initiationMethod.length > 0) {
      filters.initiationMethod.forEach((initiationMethod) => {
        queryParams.append("initiationMethod", initiationMethod.value);
      });
    }
    if (filters.intent) {
      queryParams.append("intent", filters.intent.value);
    }
    if (filters.category) {
      queryParams.append("category", filters.category.value);
    }
    if (!filters.excludeWeekends) {
      queryParams.append("excludeWeekends", filters.excludeWeekends);
    }
    if (filters.dateStart) {
      queryParams.append("dateStart", formatDateToYYYYMMDD(filters.dateStart));
    }
    if (filters.dateEnd) {
      queryParams.append("dateEnd", formatDateToYYYYMMDD(filters.dateEnd));
    }

    console.log("Testing");
    Tools.sendRequest("get-intents", queryParams.toString()).then(
      (response) => {
        let intents = response.intents;
        setIntents(intents);
        setQueues(
          Object.keys(response.queueCounts)
            .map((a) => ({
              value: a,
              label: a,
              count: response.queueCounts[a],
            }))
            .sort((a, b) => b.count - a.count) // Sort descending by count
        );
        setInitiationMethods(
          Object.keys(response.initiationMethodCounts)
            .map((a) => ({
              value: a,
              label: a,
              count: response.initiationMethodCounts[a],
            }))
            .sort((a, b) => b.count - a.count) // Sort descending by count
        );

        setTotalCalls(response.totalCalls);
        setLoadingSummary(false);

        // Since filters are also reset
        setFilteredIntents(null);
      }
    );
  }, [filters]);

  const handleFilterChange = useCallback(
    (newFilters) => {
      setFilters(newFilters);
    },
    [setFilters]
  );

  return (
    <div className="container mx-auto p-4">
      <IntentsFilter
        filters={filters}
        setFilters={handleFilterChange}
        intents={intents}
        queues={queues}
        initiationMethods={initiationMethods}
      />
      {loadingSummary ? (
        <div className="flex justify-center items-center h-64">
          <div className="loader"></div>
        </div>
      ) : (
        <>
          <IntentsTiles
            intents={intents}
            filteredIntents={filteredIntents}
            totalCalls={totalCalls}
          />
          <IntentsGrid intents={intents} onLocalFilter={onLocalFilter} />
        </>
      )}
    </div>
  );
}

export default IntentsPage;
